var cov_1e704exh2l = function () {
  var path = "/Users/spana/SHEIN/shineout/src/utils/defaultProps.ts",
      hash = "a4419cbc93e1012d8e807206d7b1c2e091bb6e56",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/utils/defaultProps.ts",
    statementMap: {
      "0": {
        start: {
          line: 9,
          column: 4
        },
        end: {
          line: 14,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

export var defaultProps = (cov_1e704exh2l.s[0]++, {
  className: '',
  size: 'default',
  style: {},
  type: 'default'
});